import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
  CSmartTable,
} from '@coreui/react-pro'
import ToastComponent from 'src/components/common/TaostComponent.js'
import PlayerService from 'src/service/PlayerService'
import EditForm from './EditForm'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'
import useDebounce from 'src/hooks/useDebounce'

const Table = ({
  users,
  setUsers,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
}) => {
  const [loading, setLoading] = useState()
  const [visibleHorizontal, setVisibleHorizontal] = useState(false)
  const [selectedPlayerId, setSelectedPlayerId] = useState(0)
  const [details, setDetails] = useState([])
  const columns = [
    {
      label: 'PID',
      key: 'id',
      _style: { width: '10%' },
    },
    {
      key: 'image',
      label: 'Image',
      filter: false,
      sorter: false,
    },
    {
      label: 'Player',
      key: 'full_name',
    },
    { label: 'Value', key: 'svalue' },
    { label: 'Position', filter: false, key: 'position_name' },
    { label: 'Use', filter: false, key: 'in_use', sorter: true },
    { label: 'Status', filter: false, key: 'is_active' },
    {
      key: 'show_details',
      label: 'Actions',
      filter: false,
      sorter: false,
    },
  ]
  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'success'
      case 0:
        return 'danger'
      default:
        return 'danger'
    }
  }

  const checkInUse = (user_team_player_exists, team_player_exists, player_id) => {
    if (user_team_player_exists === player_id) {
      return <CBadge color={'danger'}>In-Use </CBadge>
    }
    if (team_player_exists === player_id) {
      return <CBadge color={'danger'}>In-Use </CBadge>
    }
    return <CBadge color={'success'}>Not In-Use </CBadge>
  }
  const toggleDetails = (index) => {
    setSelectedPlayerId(index)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
  }

  const deletePlayer = (id) => {
    setLoading(true)
    const data = {}
    data.id = id
    const position = details.indexOf(id)
    let newDetails = details.slice()
    newDetails.splice(position, 1)
    setDetails(newDetails)
    // setUsers((previousEmployeeData) => previousEmployeeData.data.filter((data) => data.id !== id))
    PlayerService.deletePlayer(data).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        ToastComponent(res.message, 'success')
        setLoading(false)
      }
    })
  }

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [statusHandleYes, setStatusHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [statusShowConfirm, setStatusShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [statusHandleNo, setStatusHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)
  const [playerStatus, setPlayerStatus] = useState(false)

  const handleCancel = () => {
    console.log('You clicked No!')
    return setShowConfirm(false)
  }
  const handleStatusCancel = () => {
    console.log('You clicked No!')
    return setStatusShowConfirm(false)
  }

  const handleConfirm = () => {
    deletePlayer(tableId)
    return setShowConfirm(false)
  }
  const handleStatusConfirm = () => {
    handleStatus(tableId, playerStatus)
    return setStatusShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    const data = {}
    data.id = id
    data.type = 'player'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }
  const handleAreYouSureStatus = (id, status) => {
    const data = {}
    data.id = id
    data.type = 'player_status'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setStatusShowConfirm(true)
          setTableId(id)
          setPlayerStatus(status)
        }
      }
    })
  }

  const handleStatus = (id, status) => {
    PlayerService.updateStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers()
          ToastComponent(res.message, 'success')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
  }

  const debouncedFilter = useDebounce(columnFilter, 500)
  const debouncedSorter = useDebounce(columnSorter, 500)

  useEffect(() => {
    fetchUsers() // ← API call now fires ONLY AFTER 500ms (debounced)
  }, [debouncedFilter, debouncedSorter, activePage, itemsPerPage])
  return (
    <>
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          image: (item) => (
            <td>
              {item?.is_avatar === 1 ? (
                <img
                  src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item.image}`}
                  alt="img"
                  width="50"
                  height="50"
                />
              ) : (
                <img
                  src={`${process.env.REACT_APP_API_URL}uploads/player/${item.image}`}
                  width="50"
                  height="50"
                  alt="img"
                />
              )}
            </td>
          ),
          svalue: (item) => <td>${item.svalue}m</td>,
          in_use: (item) => (
            <td>
              {item.in_use === 1 ? (
                <CBadge color="danger">In-Use</CBadge>
              ) : (
                <CBadge color="success">Free</CBadge>
              )}
            </td>
          ),

          is_active: (item) => (
            <td>
              {' '}
              {item.is_active === 1 ? (
                <CBadge color={'success'}>Activated</CBadge>
              ) : (
                <CBadge color={'danger'}>Deactivated</CBadge>
              )}
            </td>
          ),
          show_details: (item) => {
            return (
              <>
                <td className="py-2">
                  <CButton
                    color="primary"
                    variant="outline"
                    shape="square"
                    size="sm"
                    onClick={() => {
                      toggleDetails(item.id)
                    }}
                  >
                    {details.includes(item.id) ? 'Hide' : 'Manage'}
                  </CButton>
                </td>
              </>
            )
          },
          details: (item) => {
            return (
              <CCollapse visible={details.includes(item.id)}>
                <CCardBody>
                  <CButton
                    size="sm"
                    color="success"
                    className="ml-1"
                    onClick={() => setVisibleHorizontal(!visibleHorizontal)}
                    aria-expanded={visibleHorizontal}
                    aria-controls="collapseEdit"
                  >
                    Edit
                  </CButton>
                  <CButton
                    size="sm"
                    color="danger"
                    className="ml-1"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    Delete
                  </CButton>
                  {item.is_active === 1 ? (
                    <CButton
                      size="sm"
                      color="dark"
                      className="ml-1"
                      onClick={() => handleAreYouSureStatus(item.id, 0)}
                    >
                      Deactivate
                    </CButton>
                  ) : (
                    <CButton
                      size="sm"
                      color="dark"
                      className="ml-1"
                      onClick={() => handleAreYouSureStatus(item.id, 1)}
                    >
                      Activate
                    </CButton>
                  )}
                  <CCollapse id="collapseEdit" horizontal visible={visibleHorizontal}>
                    <CCard className="mb-4">
                      <CCardHeader>
                        <strong>Edit Player</strong>
                      </CCardHeader>
                      <CCardBody>
                        <EditForm
                          playerId={item.id}
                          selectedPlayerId={selectedPlayerId}
                          fetchUsers={fetchUsers}
                          toggleDetails={toggleDetails}
                        />
                      </CCardBody>
                    </CCard>
                  </CCollapse>
                </CCardBody>
              </CCollapse>
            )
          },
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
      <Notify
        setShowConfirm={setStatusShowConfirm}
        showConfirm={statusShowConfirm}
        setHandleNo={setStatusHandleNo}
        handleNo={statusHandleNo}
        handleYes={statusHandleYes}
        setHandleYes={setStatusHandleYes}
        handleConfirm={handleStatusConfirm}
        handleCancel={handleStatusCancel}
        text="Are you sure you want to change player status?"
      />
    </>
  )
}

export default Table
